import { isSingleValueObject } from "../value-objects";
export class Entity {
    static toJson(entity) {
        let json = {};
        Object.keys(entity.v).forEach((k) => {
            const v = entity.v[k];
            if (v === undefined) {
                return;
            }
            if (isSingleValueObject(v)) {
                json[k] = v.toJson();
            }
            else {
                json = {
                    ...json,
                    ...v.toJson(),
                };
            }
        });
        return json;
    }
}
//# sourceMappingURL=entity.js.map